<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-13 15:44:49
 * @FilePath: \mrc-ess-fronted\src\Page\Other\Roster\Roster.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-15 12:04:56
-->
<template>
  <!--startprint-->
  <div>
    <!-- <v-btn @click="getPdf('#pdfDom')" rounded color="primary">导出</v-btn> -->
    <v-fab-transition>
      <v-btn
        fab
        v-if="canPrint"
        rounded
        color="primary"
        bottom
        :loading="loading || isLoading || showLoading"
        right
        :disabled="loading || isLoading || showLoading"
        fixed
        @click="toPrint"
      >
        <span class="material-icons-round">print</span>
      </v-btn>
    </v-fab-transition>
    <ContentLayout
      ref="print"
      :title="$t('label_essweb_RosterRecord_list_title')"
      pad="0"
      hiddenNav
      backgroundClass="white"
      widthClass="min-1600"
    >
      <!-- :style="{
        transform: 'rotate(90deg)',
        '-ms-transform': 'rotate(90deg)' /* IE 9 */,
        '-moz-transform': 'rotate(90deg)' /* Firefox */,
        '-webkit-transform': 'rotate(90deg)' /* Safari 和 Chrome */,
        '-o-transform': 'rotate(90deg)',
      }" -->
      <!-- content -->
      <template v-slot:page-main>
        <v-container
          fluid
          class="pa-0 ma-0"
          :style="{
            height: $vuetify.breakpoint.height + 'px',
            overflow: 'overlay',
          }"
        >
          <RosterPlan
            id="pdfDom"
            v-if="page_params"
            ref="printarea2"
            :token="page_params.token"
            :cycleType="cycleType"
            :showExportIn="showExportIn"
            @closeExportIn="showExportIn = false"
            @closeCalcul="showRecalcul = false"
            :toDo="toDo"
            @loadingData="
              (v) => {
                showLoading = v;
              }
            "
            @back="
              isEdited = false;
              dateTerminal = { start: '', end: '', vaue: '' };
            "
            :showRosterForm="showRosterForm"
            @closeRosterForm="showRosterForm = false"
            :showRecalcul="showRecalcul"
            :startTime="startTime"
            :isEdited="isEdited"
            :selectStartDate="startDate"
            :selectEndDate="endDate"
            :endTime="endTime"
            @onTrigerPage="
              (logic) => {
                toResetTime(logic);
              }
            "
            @check="
              (staffs) => {
                selectStaffs = staffs;
              }
            "
          />
        </v-container>
        <v-container
          fluid
          class="ma-0 pa-0 d-flex flex-row justify-space-around"
        >
          <v-container fluid class="ma-0 pa-0 mr-6">
            <v-sheet class="text-subtile-2 pl-4"
              >{{ $t("label_essweb_shift_list_title") }}：</v-sheet
            >
            <Tabler
              :headers="headers"
              :items="desserts"
              :avPerPage="50"
              contentClass=" pa-4 py-0"
              defaultDense
              :showFooter="false"
              :sortBy="['startTime']"
            >
              <template v-slot:item.color="{ item }">
                <div style="max-width: 20px">
                  <svg-icon
                    size="24"
                    :fill="item.color_code"
                    iconClass="LabeledColour"
                  />
                </div>
              </template>
              <template v-slot:item.name="{ item }">
                <div
                  class="text--primary table-title"
                  :title="$getCommonLangValue(item.shift_name)"
                >
                  {{ $getCommonLangValue(item.shift_name) }}
                </div>
                <div class="table-subtitle text--secondary">
                  {{ $getCommonLangValue(item.shift_description) }}
                </div>
              </template>
              <template v-slot:item.abbr="{ item }">
                <div class="text--primary table-title">
                  {{ item.shift_abbr }}
                </div>
              </template>
              <template v-slot:item.startTime="{ item }">
                <div class="text--primary table-title">
                  {{ $timeMachine(item.start_utc_time) }}
                  <!-- <template
              >({{ $getUtcByCode(item.start_time_time_zone) }})</template
            > -->
                </div>
              </template>

              <template v-slot:item.endTime="{ item }">
                <div class="text--primary table-title">
                  {{ $timeMachine(item.end_utc_time) }}
                  <!-- ({{
              $getUtcByCode(item.end_time_time_zone)
            }}) -->
                </div>
              </template>
              <template v-slot:item.count="{ item }">
                <div class="text--primary table-title">
                  {{ item.total_working_minutes
                  }}{{ $t("label_essweb_system_minutesLabel") }}
                </div>
              </template>
            </Tabler>
          </v-container>
          <v-spacer></v-spacer>
          <v-container fluid class="pa-0 ma-0 ml-6">
            <v-sheet class="text-subtile-2 ml-6"
              >{{ $t("label_essweb_holiday_list_title") }}：</v-sheet
            >

            <Tabler
              :headers="headers1"
              :items="desserts1"
              defaultDense
              contentClass=" pa-4 py-0"
              :avPerPage="50"
              :showFooter="false"
            >
              <template v-slot:item.name="{ item }">{{
                $getCommonLangValue(item.holiday_name)
              }}</template>
              <template v-slot:item.date="{ item }">{{
                $getDateTime(item.holiday_utc_date, "YYYY/MM/DD")
              }}</template>
              <template v-slot:item.zone="{ item }">{{
                $getUtcByCode(item.holiday_time_zone)
              }}</template>
            </Tabler>
          </v-container>
        </v-container>
      </template>
      <!-- actions -->
      <template v-slot:page-actions> </template>
      <template v-slot:tools-main>
        <printLoading :show="showLoading" />
      </template>
    </ContentLayout>
    <!--endprint-->
  </div>
</template>
<script>
import dayjs from "dayjs";
import RosterPlan from "@/Page/Other/Roster/components/RosterPlan";
import printLoading from "@/Page/Other/Roster/components/printLoading";
import { mapGetters } from "vuex";
export default {
  name: "RosterRecord",
  components: { RosterPlan, printLoading },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  data() {
    return {
      cycleType: 30,
      canPrint: true,
      loading: false,
      page_params: {
        start_date: "",
        end_date: "",
        token: "",
      },
      step: 2,
      htmlTitle: "pdf",
      showExportIn: false,
      showExportOut: false,
      showRosterForm: false,
      showRecalcul: false,
      curStep: 1,
      toDo: "",
      isEdited: false,
      startTime: "2020-07-09",
      endTime: "2020-09-09",
      showMenu: false,
      selectStaffs: [],
      showLoading: false,
      dateTerminal: { start: "", end: "", value: "" },
      saveStartDate: "",
      saveEndDate: "",
      defaultStartDate: "",
      defaultEndDate: "",
      startDate: "",
      endDate: "",
      desserts: [],
      desserts1: [],
      headers: [
        {
          text: "label_essweb_list_components_tools_colorLabel",
          value: "color",
          align: "start",
          width: 24,
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_StartTimeSlotLabel",
          value: "startTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_EndTimeSlotLabel",
          value: "endTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_totalMinutesLabel",
          value: "count",
          align: "start",
          sortable: false,
        },
      ],
      headers1: [
        {
          text: "label_essweb_holiday_list_publicHolidayLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holiday_list_dateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holiday_list_timeZoneLabel",
          value: "zone",
          align: "start",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    isEdited() {
      this.selectStaffs = [];
    },
    startDate(val) {
      if (val) {
        this.startTime = val;
        this.endTime = dayjs(val)
          .add(this.cycleType - 1, "day")
          .format("YYYY-MM-DD");
      }
    },
    dateTerminal(val) {
      if (!val.value) {
        this.startDate = "";
        this.endDate = "";
        this.saveStartDate = this.startDate;
        this.saveEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.defaultEndDate = this.endDate;
      }
    },
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.args));
    this.startTime = this.page_params.start_date
      ? this.page_params.start_date
      : this.resettingTime()[0];
    this.endTime = this.page_params.end_date
      ? this.page_params.end_date
      : this.resettingTime()[1];
    if (this.page_params.token) {
      this.getList();
      this.getList2();
    }

    // console.log(this.endTime);
    // console.log(this.startTime);
    // console.log(dayjs().subtract(this.cycleType, "day").format("YYYY-MM-DD"));
  },
  methods: {
    toPrint() {
      const that = this;
      if (this.isLoading) return;
      this.loading = true;
      this.$store.dispatch("setLoading", true).then(() => {
        that.loading = false;
        this.$Sleep(1500).then(() => {
          that.getPdf("#pdfDom");
        });
      });
      // var bdhtml = this.$refs.printarea2;
      // this.$print(this.$refs.print);
    },
    setDateTerminal: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      } else {
        this.showMenu = false;
        this.isEdited = true;
        this.startDate = this.dateTerminal.start;
        this.endDate = this.dateTerminal.end;
        this.saveStartDate = this.startDate;
        this.saveEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.defaultEndDate = this.endDate;
      }
    },
    reviewDateTerminal: function () {
      this.startDate = this.saveStartDate;
      this.endDate = this.saveEndDate;
      this.defaultStartDate = this.saveStartDate;
      this.defaultEndDate = this.saveEndDate;
      this.dateTerminal = {
        start: this.saveStartDate,
        end: this.saveEndDate,
        value: this.saveStartDate
          ? this.saveStartDate + " - " + this.saveEndDate
          : "",
      };
    },
    //  重设时间
    resettingTime: function (start, logic = "add") {
      let end = "";
      if (!start) {
        start = dayjs().format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs()
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs().subtract(this.cycleType, "day").format("YYYY-MM-DD");
          return [end, start];
        }
      } else {
        start = dayjs(start).format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs(start)
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs(start)
            .subtract(this.cycleType, "day")
            .format("YYYY-MM-DD");
          return [end, start];
        }
      }
    },
    toResetTime: function (logic) {
      let start = this.startTime;
      let end = this.endTime;
      if (!logic) {
        this.startTime = this.resettingTime()[0];
        this.endTime = this.resettingTime()[1];
      } else {
        if (logic == "add") {
          this.startTime = this.resettingTime(end, "add")[0];
          this.endTime = this.resettingTime(end, "add")[1];
        } else {
          this.startTime = this.resettingTime(start, "red")[0];
          this.endTime = this.resettingTime(start, "red")[1];
        }
      }
    },
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-list/",
        data: { token: this.page_params.token },
      }).then((res) => {
        res.data.forEach(function (item) {
          if (item.shift_type_uuid.indexOf(",") != -1) {
            item.shift_type_uuid = item.shift_type_uuid.split(",");
          } else {
            item.shift_type_uuid = [item.shift_type_uuid];
          }
          if (item.shift_property_group_uuid.indexOf(",") != -1) {
            item.shift_property_group_uuid =
              item.shift_property_group_uuid.split(",");
          } else {
            item.shift_property_group_uuid = [item.shift_property_group_uuid];
          }
        });
        that.desserts = res.data;
      });
    },
    getList2: function () {
      const that = this;

      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/get-holiday-list/",
        data: {
          token: this.page_params.token,
        },
      }).then((res) => {
        // 排序
        res.data.sort((objectN, objectM) => {
          var valueN = objectN["holiday_utc_date"];
          var valueM = objectM["holiday_utc_date"];
          if (valueN < valueM) return 1;
          else if (valueN > valueM) return -1;
          else return 0;
        });
        that.desserts1 = res.data;
      });
    },
    toNext: function () {
      if (this.selectStaffs.length <= 0) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_rosterFormRecord_form_selectStaffLabel"
          ),
          type: "warning",
        });
        return false;
      }
      this.showRosterForm = true;
    },
  },
};
</script>
